import { render } from "./RawMaterial.vue?vue&type=template&id=36cd631d"
import script from "./RawMaterial.vue?vue&type=script&lang=js"
export * from "./RawMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__